import React from 'react';
import { graphql, QueryRenderer } from 'react-relay';
import { Select, MenuItem, InputLabel, } from '@material-ui/core';
import environment from '../../environment';
import { withStyles } from '@material-ui/styles';
import { useStyles } from './styles';
const axios = require('axios');

class DatagolfTourList extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            list: [],
        }

        this.handleChange = this.handleChange.bind(this);
    }

    componentDidMount(){
        axios.post('/getPGAschedule')
        .then(res => {
            if(res && res.data){
                this.setState({ list: res.data });
            }
        })
    }

    handleChange(e){
        this.props.datagolfSelect(e.target.value);
    }

    render(){
        const { tour, classes } = this.props;
        return ([
            <InputLabel shrink={true} style={{fontSize: '20px', top: '-5px', fontWeight: 'bold'}}>
                Select Tournament
            </InputLabel>,
            <Select
                fullWidth
                variant="standard"
                value={tour}
                onChange={this.handleChange}
                label="PGA Event"
            >
                <MenuItem value=""></MenuItem>
            {
                this.state.list.map(event => (
                    <MenuItem value={event.event_name} key={`pga-event-${event.event_id}`}>
                        {event.event_name}
                    </MenuItem>
                ))
            }
            </Select>
        ])
    }
}

export default withStyles(useStyles)(DatagolfTourList);